import React from "react";

const TemperatureOutlined = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2926_9887"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2926_9887)">
        <path
          d="M12 20.5C10.7513 20.5 9.68917 20.0622 8.8135 19.1865C7.93783 18.3108 7.5 17.2487 7.5 16C7.5 15.2385 7.67825 14.5343 8.03475 13.8875C8.39108 13.2407 8.8795 12.7013 9.5 12.2692V6C9.5 5.30133 9.742 4.71 10.226 4.226C10.71 3.742 11.3013 3.5 12 3.5C12.6987 3.5 13.29 3.742 13.774 4.226C14.258 4.71 14.5 5.30133 14.5 6V12.2692C15.1205 12.7013 15.6073 13.2407 15.9605 13.8875C16.3137 14.5343 16.4935 15.2385 16.5 16C16.4935 17.2487 16.0525 18.3108 15.177 19.1865C14.3013 20.0622 13.2423 20.5 12 20.5ZM12 19C12.8333 19 13.5417 18.7083 14.125 18.125C14.7083 17.5417 15 16.8333 15 16C15 15.5167 14.8958 15.0667 14.6875 14.65C14.4792 14.2333 14.1833 13.8833 13.8 13.6L13 13V6C13 5.71667 12.9042 5.47917 12.7125 5.2875C12.5208 5.09583 12.2833 5 12 5C11.7167 5 11.4792 5.09583 11.2875 5.2875C11.0958 5.47917 11 5.71667 11 6V13L10.2 13.6C9.81667 13.8833 9.52083 14.2333 9.3125 14.65C9.10417 15.0667 9 15.5167 9 16C9 16.8333 9.29167 17.5417 9.875 18.125C10.4583 18.7083 11.1667 19 12 19Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default TemperatureOutlined;
